import {
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, InputMultImg } from "../../../../controls";
import { DropLi, Model, UseForm } from "../../../../hooks";
import { Alert, Tabs } from "../../../../layout";
import { ArrowBackRounded } from "@mui/icons-material";
import ProdVariants from "./ProdVariants";
import Composite from "./Composite";
import StandardProd from "./StandardProd";
import { AppContext } from "../../../../App";
import { API, action, controller } from "../../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../../hooks/Method";
import InputProdType from "./InputProdType";
import InputCategory from "./QuickAdding/InputCategory";
import InputBrand from "./QuickAdding/InputBrand";
import InputTags from "./QuickAdding/InputTags";
import InputSupplier from "./QuickAdding/InputSupplier";
import SectionLabel from "./SectionLabel";

const AddEditProd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { ProdType } = DropLi();
  const { ProdMdl } = Model();
  const { authUser, setLoader } = useContext(AppContext);
  const { values, errors, setErrors, handleInpChg, setValues, handleFile } =
    UseForm(ProdMdl);
  const { SkuTypes } = DropLi();
  const [loading, setLoading] = useState(false);
  const [outlets, setOutlets] = useState([]);
  const [imgSrc, setImgSrc] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    API(controller.Outlet + action.GetAllByOrg).get((res) => {
      res.status === 200 &&
        setOutlets([...res.result.map((j) => ({ ...j, label: j.outletName }))]);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  useEffect(() => {
    if (id) {
      setLoader(true);
      API(controller.Product + action.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = RmvEmptyProp(res.result);
          setValues((x) => ({
            ...x,
            ...val,
            imgFiles: [],
            prodTags: [...val.prodTags.map((j) => j.tagId)],
            prodSuppliers: [...val.prodSuppliers.map((j) => j.supplierId)],
            inventories: [
              ...val.inventories.map((i) => ({
                ...i,
                outletName: i.outlet?.outletName,
                inInv: i.inInv || 0,
                reOrderPoint: i.reOrderPoint || "",
                reOrderQty: i.reOrderQty || "",
              })),
            ],
            prodVarAttrs: val.prodVarAttrs.map((j) => ({
              ...j,
              value: [...j.values.map((y) => y.name)],
            })),
            prodVariants: [
              ...val.prodVariants.map((variant) => ({
                ...variant,
                imgFiles: [],
                inventories: [
                  ...variant.inventories.map((i) => ({
                    ...i,
                    outletName: i.outlet?.outletName,
                    inInv: i.inInv || 0,
                    reOrderPoint: i.reOrderPoint || "",
                    reOrderQty: i.reOrderQty || "",
                  })),
                ],
              })),
            ],
            compositProds: [
              ...val.compositProds.map((j) => {
                var prodDtl = j.isVariant ? j.varProd : j.prod;
                var subtitle = j.isVariant
                  ? j.varProd.attrVal1 +
                    (j.varProd.attrVal2 && ` / ${j.varProd.attrVal2}`) +
                    (j.varProd.attrVal3 && ` / ${j.varProd.attrVal3} | `) +
                    (j.varProd.skuCode && ` | ${j.varProd.skuCode} | `) +
                    `$${j.varProd.splrPrice}`
                  : "";

                return {
                  ...j,
                  name: j.isVariant ? j.varProd.product.name : j.prod.name,
                  subtitle,
                  splrPrice: prodDtl && prodDtl.splrPrice,
                  prod: prodDtl,
                };
              }),
            ],
          }));
          setImgSrc([...val.imgs.map((j) => ({ src: j.imgUrl, ...j }))]);
        }
        setLoader(false);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    // This will work only first time or product adding time.
    if (
      outlets.length > 0 &&
      values.id === 0 &&
      (values.inventories.length === 0 || !values.trackInv)
    ) {
      setValues((j) => ({
        ...j,
        inventories: [
          ...outlets.map((y) => ({
            outletName: y.outletName,
            outletId: y.id,
            inInv: 0,
            reOrderPoint: "",
            reOrderQty: "",
            orgId: authUser.orgId || "",
          })),
        ],
      }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outlets, values.trackInv]);

  // Calculate composit product price
  useEffect(() => {
    if (values.prodType === 3) {
      const markup = parseFloat(values.markup || 0);
      var splrPrice = parseFloat(
        values.compositProds
          .map((j) => j.splrPrice * j.qty)
          .reduce((x, y) => x + y, 0)
      );

      setValues((j) => ({
        ...j,
        rtlPrice: (splrPrice + (splrPrice * markup) / 100 || 0).toFixed(2),
      }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.compositProds]);

  const validateForm = () => {
    let temp = {};
    temp.firstName = values.firstName !== "" ? "" : "First Name is required.";
    temp.lastName = values.lastName !== "" ? "" : "Last Name is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = () => {
    if (validateForm() && authUser.id) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res) {
          if (res.status === 201 || res.status === 200) {
            navigate("/products");
          } else {
            setAlert({
              isOpen: true,
              type: "error",
              title: "Error",
              subTitle: res.msg,
            });
          }
        }
      };

      values.prodTags = values.prodTags.map((j) => ({ ...j, tagId: j }));
      values.prodSuppliers = values.prodSuppliers.map((j) => ({
        ...j,
        supplierId: j,
      }));

      if (values.id === 0) {
        if (values.prodType === 2) values.inventories = [];
        else values.prodVarAttrs = [];

        if (values.prodType !== 3) values.compositProds = [];

        API(controller.Product + action.Post).post(
          ToFormData({
            ...values,
            prodVarAttrs: values.prodVarAttrs.map((j) => ({
              attrId: j.attrId,
              values: [...j.value.map((x) => ({ name: x }))],
            })),
          }),
          onComplete
        );
      } else {
        API(controller.Product + action.Put).put(
          ToFormData({
            ...values,
            outletId: "",
            outlet: "",
            user: "",
            subcat: "",
            cat: "",
            inventories: values.prodType !== 1 ? "" : values.inventories,
            updateDate: new Date().toISOString(),
            prodVarAttrs: values.prodVarAttrs.map((j) => ({
              ...j,
              values: j.value ? [...j.value.map((x) => ({ name: x }))] : "",
            })),
            compositProds: values.compositProds.map((j) => ({
              ...j,
              prod: "",
              varProd: "",
            })),
          }),
          onComplete
        );
      }
    }
  };

  const calculateMarkup = (e) => {
    var splrPrice =
      (values.prodType === 3
        ? values.compositProds
            .map((j) => j.splrPrice * j.qty)
            .reduce((x, y) => x + y, 0)
        : values.splrPrice) || 0;

    var rtlPrice = parseFloat(e.target.value) || 0;

    var markup = splrPrice
      ? (((rtlPrice - splrPrice) / splrPrice) * 100).toFixed(2)
      : 0;
    setValues((j) => ({
      ...j,
      markup,
    }));
  };

  // Calculate Retail Price.
  useEffect(() => {
    var splrPrice = parseFloat(
      values.prodType === 3
        ? values.compositProds
            .map((j) => j.splrPrice * j.qty)
            .reduce((x, y) => x + y, 0)
        : values.splrPrice || 0
    );

    setValues((j) => ({
      ...j,
      rtlPrice: (
        splrPrice + (splrPrice * parseFloat(values.markup || 0)) / 100 || 0
      ).toFixed(2),
    }));

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.markup, values.splrPrice]);

  useEffect(() => {
    if (values.prodType === 3) {
      setValues((j) => ({
        ...j,
        trackInv: false,
        splrId: "",
        splrCode: "",
        splrPrice: "",
      }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.prodType]);

  return (
    <>
      <Paper>
        <div className="flex justify-between items-center p-[10px]">
          <div className="flex items-center gap-[10px]">
            <div>
              <IconButton size="small" onClick={() => navigate(-1)}>
                <ArrowBackRounded />
              </IconButton>
            </div>

            <div>
              <h1 className="form-title font-medium text-gray-500 uppercase">
                {id ? "Edit" : "Add"} Product
              </h1>
            </div>
          </div>

          <div>
            <Button onClick={handleSubmit} loading={loading}>
              {id ? "Save Changes" : "Submit"}
            </Button>
          </div>
        </div>
        <Divider />
        <div className="pl-[15px] pr-[15px] pb-[15px]">
          <Tabs
            className="mt-[30px]"
            header={[
              { label: "General Fields", icon: "" },
              { label: "Inventory Fields", icon: "" },
            ]}
          >
            {/* -------- General Fields -------- */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={8}>
                <Input
                  label="Name"
                  name="name"
                  required={true}
                  value={values.name}
                  error={errors.name}
                  inputProps={{ maxLength: 300 }}
                  onChange={handleInpChg}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputBrand {...{ values, setValues, errors, handleInpChg }} />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputTags {...{ values, setValues, handleInpChg }} />
              </Grid>
              {/* Category and Subcategory Section */}
              <InputCategory {...{ values, setValues, handleInpChg }} />
              <Grid item xs={12}>
                <Input
                  label="Description"
                  name="desc"
                  required={true}
                  value={values.desc}
                  error={errors.desc}
                  inputProps={{ maxLength: 500 }}
                  multiline
                  rows={3}
                  onChange={handleInpChg}
                />
              </Grid>

              <Grid item xs={12}>
                <div className="flex flex-wrap gap-[10px]">
                  <InputMultImg
                    label="Product Images"
                    name="imgFiles"
                    maxUpl={5}
                    src={imgSrc}
                    values={values.imgFiles}
                    onChange={handleFile}
                    rmv={(file) => {
                      setValues((x) => ({
                        ...x,
                        imgFiles: x.imgFiles.filter(
                          (j) => j.lastModified !== file.lastModified
                        ),
                        imgs: x.imgs.filter((j) => j.id !== file.id),
                      }));
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            {/* -------- Inventory Fields -------- */}
            <Grid container spacing={3}>
              {/* Product Type */}
              {!values.id && (
                <Grid item xs={12}>
                  <InputProdType
                    name="prodType"
                    value={values.prodType}
                    onChange={handleInpChg}
                    options={ProdType}
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <SectionLabel label="Supplier Information" />
              </Grid>

              {values.prodType !== 3 && (
                <>
                  <Grid item xs={12} md={6}>
                    <InputSupplier
                      {...{
                        values,
                        setValues,
                        handleInpChg,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Input
                      label="Supplier Code"
                      name="splrCode"
                      value={values.splrCode}
                      inputProps={{ maxLength: 100 }}
                      onChange={handleInpChg}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Input
                      label="Supplier Price"
                      name="splrPrice"
                      type="number"
                      value={values.splrPrice}
                      onChange={handleInpChg}
                      placeholder="$ 0.00"
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4}>
                <Input
                  label="Markup"
                  name="markup"
                  placeholder="0.00"
                  type="number"
                  value={values.markup}
                  onChange={handleInpChg}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">%</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Input
                  label="Retail price"
                  name="rtlPrice"
                  placeholder="$ 0.00"
                  type="number"
                  value={values.rtlPrice}
                  inputProps={{ maxLength: 100 }}
                  onChange={handleInpChg}
                  onBlur={calculateMarkup}
                />
              </Grid>

              {values.prodType === 1 && (
                <StandardProd
                  {...{
                    setValues,
                    values,
                    handleInpChg,
                    SkuTypes,
                  }}
                />
              )}
              {values.prodType === 2 && (
                <ProdVariants {...{ setValues, values, outlets }} />
              )}
              {values.prodType === 3 && (
                <>
                  <StandardProd
                    {...{
                      setValues,
                      values,
                      handleInpChg,
                      SkuTypes,
                    }}
                  />
                  <Composite {...{ setValues, values }} />
                </>
              )}
            </Grid>
          </Tabs>
        </div>
      </Paper>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};
export default AddEditProd;
